// Cookie banner. Choice is stored in localStorage under "nexin-consent".
// The Meta Pixel loads on accept
// (window.nexinMetaGrant, defined by shared/_meta_pixel).
declare global {
  interface Window {
    nexinMetaGrant?: () => void
    nexinMetaFlushPending?: () => void
    nexinMetaDropPending?: () => void
  }
}

const KEY = 'nexin-consent'
const banner = document.querySelector<HTMLElement>('[data-cookie-consent]')

function stored(): string | null {
  try {
    return localStorage.getItem(KEY)
  } catch {
    return null
  }
}

if (banner && !stored()) {
  banner.hidden = false
  banner.addEventListener('click', (event) => {
    const choice = (event.target as HTMLElement).closest<HTMLElement>('[data-consent]')?.dataset.consent
    if (!choice) return
    try {
      localStorage.setItem(KEY, choice)
    } catch {
      // Private mode: the banner shows again next visit.
    }
    if (choice === 'granted') {
      window.nexinMetaGrant?.()
      window.nexinMetaFlushPending?.()
    } else {
      window.nexinMetaDropPending?.()
    }
    banner.hidden = true
  })
}

export {}
